/**
 * Specifies pivot external events
 *
 * @hidden
 */
/** @hidden */
export const load = 'load';
/** @hidden */
export const enginePopulating = 'enginePopulating';
/** @hidden */
export const enginePopulated = 'enginePopulated';
/** @hidden */
export const onFieldDropped = 'onFieldDropped';
/** @hidden */
export const fieldDrop = 'fieldDrop';
/** @hidden */
export const beforePivotTableRender = 'beforePivotTableRender';
/** @hidden */
export const afterPivotTableRender = 'afterPivotTableRender';
/** @hidden */
export const beforeExport = 'beforeExport';
/** @hidden */
export const exportComplete = 'exportComplete';
/** @hidden */
export const excelHeaderQueryCellInfo = 'excelHeaderQueryCellInfo';
/** @hidden */
export const pdfHeaderQueryCellInfo = 'pdfHeaderQueryCellInfo';
/** @hidden */
export const excelQueryCellInfo = 'excelQueryCellInfo';
/** @hidden */
export const pdfQueryCellInfo = 'pdfQueryCellInfo';
/** @hidden */
export const onPdfCellRender = 'onPdfCellRender';
/** @hidden */
export const dataBound = 'dataBound';
/** @hidden */
export const queryCellInfo = 'queryCellInfo';
/** @hidden */
export const headerCellInfo = 'headerCellInfo';
/** @hidden */
export const hyperlinkCellClick = 'hyperlinkCellClick';
/** @hidden */
export const resizing = 'resizing';
/** @hidden */
export const resizeStop = 'resizeStop';
/** @hidden */
export const cellClick = 'cellClick';
/** @hidden */
export const drillThrough = 'drillThrough';
/** @hidden */
export const beforeColumnsRender = 'beforeColumnsRender';
/** @hidden */
export const selected = 'selected';
/** @hidden */
export const selecting = 'selecting';
/** @hidden */
export const cellSelecting = 'cellSelecting';
/** @hidden */
export const drill = 'drill';
/** @hidden */
export const cellSelected = 'cellSelected';
/** @hidden */
export const cellDeselected = 'cellDeselected';
/** @hidden */
export const rowSelected = 'rowSelected';
/** @hidden */
export const rowDeselected = 'rowDeselected';
/** @hidden */
export const beginDrillThrough = 'beginDrillThrough';
/** @hidden */
export const editCompleted = 'editCompleted';
/** @hidden */
export const multiLevelLabelClick = 'multiLevelLabelClick';
/** @hidden */
export const saveReport = 'saveReport';
/** @hidden */
export const fetchReport = 'fetchReport';
/** @hidden */
export const loadReport = 'loadReport';
/** @hidden */
export const renameReport = 'renameReport';
/** @hidden */
export const removeReport = 'removeReport';
/** @hidden */
export const newReport = 'newReport';
/** @hidden */
export const toolbarRender = 'toolbarRender';
/** @hidden */
export const toolbarClick = 'toolbarClick';
/** @hidden */
export const chartTooltipRender = 'chartTooltipRender';
/** @hidden */
export const chartLegendClick = 'chartLegendClick';
/** @hidden */
export const chartLoaded = 'chartLoaded';
/** @hidden */
export const multiLevelLabelRender = 'multiLevelLabelRender';
/** @hidden */
export const beforePrint = 'beforePrint';
/** @hidden */
export const animationComplete = 'animationComplete';
/** @hidden */
export const legendRender = 'legendRender';
/** @hidden */
export const textRender = 'textRender';
/** @hidden */
export const pointRender = 'pointRender';
/** @hidden */
export const seriesRender = 'seriesRender';
/** @hidden */
export const chartMouseMove = 'chartMouseMove';
/** @hidden */
export const chartMouseClick = 'chartMouseClick';
/** @hidden */
export const pointMove = 'pointMove';
/** @hidden */
export const chartMouseLeave = 'chartMouseLeave';
/** @hidden */
export const chartMouseDown = 'chartMouseDown';
/** @hidden */
export const chartMouseUp = 'chartMouseUp';
/** @hidden */
export const dragComplete = 'dragComplete';
/** @hidden */
export const zoomComplete = 'zoomComplete';
/** @hidden */
export const scrollStart = 'scrollStart';
/** @hidden */
export const scrollEnd = 'scrollEnd';
/** @hidden */
export const scrollChanged = 'scrollChanged';
/** @hidden */
export const chartLoad = 'chartLoad';
/** @hidden */
export const chartResized = 'chartResized';
/** @hidden */
export const chartAxisLabelRender = 'chartAxisLabelRender';
/** @hidden */
export const chartSeriesCreated = 'chartSeriesCreated';
/** @hidden */
export const aggregateCellInfo = 'aggregateCellInfo';
/** @hidden */
export const onHeadersSort = 'onHeadersSort';
/** @hidden */
export const contextMenuClick = 'contextMenuClick';
/** @hidden */
export const contextMenuOpen = 'contextMenuOpen';
/** @hidden */
export const fieldListRefreshed = 'fieldListRefreshed';
/** @hidden */
export const conditionalFormatting = 'conditionalFormatting';
/** @hidden */
export const beforePdfExport = 'beforePdfExport';
/** @hidden */
export const beforeExcelExport = 'beforeExcelExport';
/** @hidden */
export const memberFiltering = 'memberFiltering';
/** @hidden */
export const calculatedFieldCreate = 'calculatedFieldCreate';
/** @hidden */
export const memberEditorOpen = 'memberEditorOpen';
/** @hidden */
export const fieldRemove = 'fieldRemove';
/** @hidden */
export const numberFormatting = 'numberFormatting';
/** @hidden */
export const aggregateMenuOpen = 'aggregateMenuOpen';
/** @hidden */
export const fieldDragStart = 'fieldDragStart';
/** @hidden */
export const chartPointClick = 'chartPointClick';
/** @hidden */
export const beforeServiceInvoke = 'beforeServiceInvoke';
/** @hidden */
export const afterServiceInvoke = 'afterServiceInvoke';
/** @hidden */
export const actionBegin = 'actionBegin';
/** @hidden */
export const actionComplete = 'actionComplete';
/** @hidden */
export const actionFailure = 'actionFailure';
/**
 * Specifies pivot internal events
 */
/** @hidden */
export const initialLoad = 'initial-load';
/** @hidden */
export const uiUpdate = 'ui-update';
/** @hidden */
export const scroll = 'scroll';
/** @hidden */
export const verticalScroll = 'vertical-scroll';
/** @hidden */
export const horizontalScroll = 'horizontal-scroll';
/** @hidden */
export const contentReady = 'content-ready';
/** @hidden */
export const dataReady = 'data-ready';
/** @hidden */
export const initSubComponent = 'init-groupingbar';
/** @hidden */
export const treeViewUpdate = 'tree-view-update';
/** @hidden */
export const pivotButtonUpdate = 'pivot-button-update';
/** @hidden */
export const initCalculatedField = 'init-calculatedfield';
/** @hidden */
export const click = 'click';
/** @hidden */
export const initToolbar = 'init-toolbar';
/** @hidden */
export const initPivotPager = 'init-pivotPager';
/** @hidden */
export const initFormatting = 'init-formatting';
/** @hidden */
export const initGrouping = 'init-grouping';
/**
 * Specifies action names of actionBegin events
 */
/** @hidden */
export const sortValue = 'Sort value';
/** @hidden */
export const drillUp = 'Drill up';
/** @hidden */
export const drillDown = 'Drill down';
/** @hidden */
export const addNewReport = 'Add new report';
/** @hidden */
export const saveCurrentReport = 'Save current report';
/** @hidden */
export const saveAsCurrentReport = 'Save as current report';
/** @hidden */
export const renameCurrentReport = 'Rename current report';
/** @hidden */
export const removeCurrentReport = 'Remove current report';
/** @hidden */
export const loadReports = 'Load report';
/** @hidden */
export const openConditionalFormatting = 'Open conditional formatting dialog';
/** @hidden */
export const openNumberFormatting = 'Open number formatting dialog';
/** @hidden */
export const MdxQuery = 'MdxQuery';
/** @hidden */
export const showFieldList = 'Open field list';
/** @hidden */
export const tableView = 'Show table view';
/** @hidden */
export const chartView = 'Show chart view';
/** @hidden */
export const multipleAxis = 'Multiple Axis';
/** @hidden */
export const showLegend = 'Show legend';
/** @hidden */
export const pdfExport = 'PDF export';
/** @hidden */
export const pngExport = 'PNG export';
/** @hidden */
export const excelExport = 'Excel export';
/** @hidden */
export const csvExport = 'CSV export';
/** @hidden */
export const jpegExport = 'JPEG export';
/** @hidden */
export const svgExport = 'SVG export';
/** @hidden */
export const hideSubTotals = 'Hide sub-totals';
/** @hidden */
export const subTotalsRow = 'Show row sub-totals';
/** @hidden */
export const subTotalsColumn = 'Show column sub-totals';
/** @hidden */
export const showSubTotals = 'Show sub-totals';
/** @hidden */
export const hideGrandTotals = 'Hide grand totals';
/** @hidden */
export const grandTotalsRow = 'Show row grand totals';
/** @hidden */
export const grandTotalsColumn = 'Show column grand totals';
/** @hidden */
export const showGrandTotals = 'Show grand totals';
/** @hidden */
export const numberFormattingMenu = 'Number Formatting menu';
/** @hidden */
export const conditionalFormattingMenu = 'Conditional Formatting menu';
/** @hidden */
export const reportChange = 'Report change';
/** @hidden */
export const sortFieldTree = 'Sort field tree';
/** @hidden */
export const editCalculatedField = 'Edit calculated field';
/** @hidden */
export const sortField = 'Sort field';
/** @hidden */
export const filterField = 'Filter field';
/** @hidden */
export const removeField = 'Remove field';
/** @hidden */
export const openCalculatedField = 'Open calculated field dialog';
/** @hidden */
export const editRecord = 'Edit record';
/** @hidden */
export const saveEditedRecords = 'Save edited records';
/** @hidden */
export const addNewRecord = 'Add new record';
/** @hidden */
export const removeRecord = 'Remove record';
/** @hidden */
export const aggregateField = 'Aggregate field';
/** @hidden */
export const contextMenuCalculatedField = 'CalculatedField Context menu';
/** @hidden */
export const windowResize = 'Window resize';
/** @hidden */
export const rowPageNavigation = 'Navigate row page';
/** @hidden */
export const columnPageNavigation = 'Navigate column page';
/**
 * Specifies action names of actionComplete events
 */
/** @hidden */
export const calculatedFieldApplied = 'Calculated field applied';
/** @hidden */
export const editedRecordsSaved = 'Edited records saved';
/** @hidden */
export const newRecordAdded = 'New record added';
/** @hidden */
export const recordRemoved = 'Record removed';
/** @hidden */
export const closeFieldlist = 'Field list closed';
/** @hidden */
export const fieldTreeSorted = 'Field tree sorted';
/** @hidden */
export const reportSaved = 'Report saved';
/** @hidden */
export const newReportAdded = 'New report added';
/** @hidden */
export const reportReSaved = 'Report re-saved';
/** @hidden */
export const reportRenamed = 'Report renamed';
/** @hidden */
export const reportRemoved = 'Report removed';
/** @hidden */
export const excelExported = 'Excel exported';
/** @hidden */
export const csvExported = 'CSV exported';
/** @hidden */
export const pdfExported = 'PDF exported';
/** @hidden */
export const pngExported = 'PNG exported';
/** @hidden */
export const jpegExported = 'JPEG exported';
/** @hidden */
export const svgExported = 'SVG exported';
/** @hidden */
export const conditionallyFormatted = 'Conditional formatting applied';
/** @hidden */
export const numberFormatted = 'Number formatting applied';
/** @hidden */
export const tableViewed = 'Table view shown';
/** @hidden */
export const chartViewed = 'Chart view shown';
/** @hidden */
export const subTotalsHidden = 'Sub-totals hidden';
/** @hidden */
export const subTotalsRowShown = 'Row sub-totals shown';
/** @hidden */
export const subTotalsColumnShown = 'Column sub-totals shown';
/** @hidden */
export const subTotalsShown = 'Sub-totals shown';
/** @hidden */
export const grandTotalsHidden = 'Grand totals hidden';
/** @hidden */
export const grandTotalsRowShown = 'Row grand totals shown';
/** @hidden */
export const grandTotalsColumnShown = 'Column grand totals shown';
/** @hidden */
export const grandTotalsShown = 'Grand totals shown';
/** @hidden */
export const valueSorted = 'Value sorted';
/** @hidden */
export const calculatedFieldEdited = 'Calculated field edited';
/** @hidden */
export const fieldSorted = 'Field sorted';
/** @hidden */
export const fieldFiltered = 'Field filtered';
/** @hidden */
export const fieldRemoved = 'Field removed';
/** @hidden */
export const fieldAggregated = 'Field aggregated';
/** @hidden */
export const recordEdited = 'Record edited';
/** @hidden */
export const reportChanged = 'Report changed';
/** @hidden */
export const windowResized = 'Window resized';
/** @hidden */
export const recordUpdated = 'Records updated';
/** @hidden */
export const drillThroughClosed = 'Drill-through closed';
/** @hidden */
export const verticalScrolled = 'Vertically scrolled';
/** @hidden */
export const horizontalScrolled = 'Horizontally scrolled';
/** @hidden */
export const rowPageNavigated = 'Row page navigated';
/** @hidden */
export const columnPageNavigated = 'Column page navigated';
/** @hidden */
export const actionDropped = 'Action dropped';
/** @hidden */
export const invalidFormula = 'Invalid formula';
